module.exports = __webpack_public_path__ + "img/09.8a482bdc.jpg";